import http from './http';
import apiProcess from './utility';

function getInstallerReleases() {
  return http.get('/installation/release')
}

export function getInstallerReleasesPromise() {
  return apiProcess(getInstallerReleases)
}